import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Col, Container, Row, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingState } from '../../utilities/constants';
import PageHeader from '../../components/PageHeader';
import { useTranslation } from 'react-i18next';
import { downloadCsv, parseUserInfo } from '../../utilities/common';
import { fetchOrganizations } from '../organization/OrganizationSlice';
import { fetchCustomEmissionProfileSourceApi } from '../organization/OrganizationApi';
import Select from 'react-select';
import { toast } from 'react-toastify';
import LoadingButton from '../../components/LoadingButton';
import { transCsvHeader } from '../reports/reportHelper';

const CustomEmissionProfileSourceReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  parseUserInfo(useSelector((state) => state.users.user));
  const organizations = useSelector((state) => state.organizations.organizations);
  const loggedUserStatus = useSelector((state) => state.users.loggedUserStatus);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const onSubmitGenerateReport = async () => {
    setIsLoading(true);
    try {
      const orgId = selectedOrg?.value;
      const customEmissionProfile = await fetchCustomEmissionProfileSourceApi(orgId);
      const fileName = _.startCase(selectedOrg?.label || 'eps-report');
      const csvContent = transCsvHeader(customEmissionProfile.data);
      if (csvContent === false) {
        toast.error(t('Invalid csv file content!'));
      } else {
        downloadCsv(csvContent, `${fileName} EPS Report`);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  const reportOrgList = () => organizations?.map(item =>
    ({ label: item.orgName, value: item.orgId }));
  useEffect(() => {
    if (loggedUserStatus === LoadingState.succeeded) {
      dispatch(fetchOrganizations());
    }
  }, [loggedUserStatus, dispatch]);

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader title={t('Custom Emission Profile Report')} />
        </Col>
      </Row>
      <Row>
        {loggedUserStatus === LoadingState.succeeded && (
          <Col>
            <Form className="configuration-form-control">
              <div className="configuration-row">
                <Select
                  placeholder="Select a organization"
                  className="select"
                  options={reportOrgList()}
                  menuPortalTarget={document.body}
                  onChange={setSelectedOrg}
                  menuPlacement="top" />
                <div className="ml-3">
                  <Button
                    variant="primary"
                    type="button"
                    disabled={!selectedOrg?.value || isLoading}
                    onClick={onSubmitGenerateReport}
                  >
                    {t('Download Report')}
                  </Button>
                  <LoadingButton isLoading={isLoading} />
                </div>
              </div>
            </Form>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default CustomEmissionProfileSourceReport;
